import Link from 'next/link';
import { useRouter } from 'next/router';
import { Button, ButtonProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

type ButtonLinkProps = ButtonProps & {
   href?: string;
   useNativeBackNavigation?: boolean;
};

export const ButtonLink = forwardRef(
   ({ href, useNativeBackNavigation, ...buttonProps }: ButtonLinkProps, ref) => {
      const router = useRouter();

      if (href) {
         return (
            <Link href={href} passHref legacyBehavior>
               <Button ref={ref} as="a" {...buttonProps} />
            </Link>
         );
      }

      if (useNativeBackNavigation) {
         return <Button ref={ref} {...buttonProps} onClick={() => router.back()} />;
      }

      // Provide a fallback to ensure the component always returns a valid JSX element
      return <Button ref={ref} {...buttonProps} />;
   }
);
